export default {
  title: 'Project Reports',
  subtitle: 'Detailed analysis of projects and tasks',
  
  // Tabs
  tabs: {
    overview: 'Overview',
    timeTracking: 'Time Tracking',
    tasks: 'Tasks',
    team: 'Team',
    export: 'Export'
  },
  
  // Filters
  filters: {
    title: 'Filters',
    dateRange: 'Date Range',
    project: 'Project',
    allProjects: 'All Projects',
    user: 'User',
    allUsers: 'All Users',
    status: 'Status',
    priority: 'Priority',
    apply: 'Apply',
    reset: 'Reset',
    custom: 'Custom',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    thisYear: 'This Year',
    from: 'From Date',
    to: 'To Date'
  },
  
  // Overview
  overview: {
    title: 'Overview',
    totalProjects: 'Total Projects',
    activeProjects: 'Active Projects',
    completedProjects: 'Completed Projects',
    totalTasks: 'Total Tasks',
    completedTasks: 'Completed Tasks',
    totalTime: 'Total Time',
    billableTime: 'Billable Time',
    completionRate: 'Completion Rate',
    averageTaskTime: 'Average Task Time',
    overdueTasks: 'Overdue Tasks'
  },
  
  // Time Tracking
  timeTracking: {
    title: 'Time Tracking Report',
    byProject: 'By Project',
    byUser: 'By User',
    byTask: 'By Task',
    totalTracked: 'Total Tracked Time',
    billable: 'Billable',
    nonBillable: 'Non-Billable',
    breakdown: 'Breakdown',
    hours: 'hours',
    noData: 'No data for selected period',
    topProjects: 'Top Time-Consuming Projects',
    topUsers: 'Top Working Users',
    dailyBreakdown: 'Daily Breakdown',
    weeklyBreakdown: 'Weekly Breakdown',
    monthlyBreakdown: 'Monthly Breakdown'
  },
  
  // Tasks
  tasks: {
    title: 'Task Analysis',
    byStatus: 'By Status',
    byPriority: 'By Priority',
    byProject: 'By Project',
    completionTrend: 'Completion Trend',
    averageCompletionTime: 'Average Completion Time',
    onTimeCompletion: 'On-Time Completion',
    overdueCompletion: 'Overdue Completion',
    taskDistribution: 'Task Distribution',
    statusBreakdown: 'Status Breakdown',
    priorityBreakdown: 'Priority Breakdown'
  },
  
  // Team
  team: {
    title: 'Team Performance',
    performance: 'Performance',
    tasksCompleted: 'Tasks Completed',
    hoursWorked: 'Hours Worked',
    efficiency: 'Efficiency',
    topPerformers: 'Top Performers',
    workload: 'Workload',
    activeTasks: 'Active Tasks',
    completionRate: 'Completion Rate',
    averageTasksPerDay: 'Average Tasks Per Day'
  },
  
  // Export
  export: {
    title: 'Export Report',
    format: 'Format',
    pdf: 'PDF Document',
    excel: 'Excel Spreadsheet',
    csv: 'CSV File',
    includeCharts: 'Include Charts',
    includeDetails: 'Include Details',
    download: 'Download',
    email: 'Send Email',
    emailTo: 'Recipient',
    emailSubject: 'Subject',
    emailMessage: 'Message',
    send: 'Send',
    downloading: 'Downloading...',
    sending: 'Sending...',
    success: 'Export successful',
    error: 'Error during export',
    button: 'Export Completed Tasks',
    noData: 'No data to export'
  },
  
  // Charts
  charts: {
    loading: 'Loading data...',
    noData: 'No data to display',
    total: 'Total',
    average: 'Average',
    percentage: 'Percentage'
  },
  
  // Messages
  messages: {
    loading: 'Generating report...',
    error: 'Error loading report',
    noProjects: 'No projects in selected period',
    noTasks: 'No tasks in selected period',
    noTimeEntries: 'No time entries in selected period'
  }
};
